<button
  type="button"
  class="like"
  [class.is-on]="liked"
  [class.is-loading]="state.loading()"
  [class.anim-on]="state.animation() === 'on'"
  [class.anim-off]="state.animation() === 'off'"
  [attr.aria-label]="label"
  [attr.aria-busy]="state.busy()"
  [class.hover-locked]="state.hoverLocked()"
  (mouseleave)="state.unlockHover()"
  (click)="toggle()">
  <svg class="like__icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path class="like__fill" stroke="none" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
    <path class="like__outline" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
  </svg>
  <span class="like__label">
    <span class="like__off">Like</span>
    <span class="like__on">Liked</span>
  </span>
</button>
<span class="sr-only" aria-live="polite">{{ state.announcement() }}</span>
